import httpService from "app/services/httpService";
import config from "../../../../src/config.json";

const apiUrl = config.apiUrl;

const getMarkUp = async (query) => {
  const url = `${apiUrl}/hotel/admin/get-markup${query ? `?${query}` : ""}`;
  const data = await httpService.get(url);
  return data;
};

const addMarkUp = async (req) => {
  try {
    const url = `${apiUrl}/hotel/admin/hotel-markup`;
    const { data } = await httpService.post(url, req);
    return data;
  } catch (error) {
    throw error;
  }
};
const getBookingHistory = async (query) => {
  const url = `${apiUrl}/hotel/book-hotel-list${query ? `?${query}` : ""}`;
  const data = await httpService.get(url);
  return data;
};
const invoiceHandler = async (values) => {
  try {
    const url = `${apiUrl}/hotel/hotel-print-invoice`;
    const data = await httpService.post(url, values, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};
const getBookingDetails = async (id) => {
  try {
    const data = await httpService.get(
      `${apiUrl}/hotel/booked-hotel-refno/${id}`
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};

const offlineTicket = async (value) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/hotel/offline-hotel-booking`,
      value
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};

const getCountry = async (query) => {
  const url = `${apiUrl}/hotel/get-country-details${query ? `?${query}` : ""}`;
  const data = await httpService.get(url);
  return data;
};
const getCityByCountry = async (query) => {
  const url = `${apiUrl}/hotel/city-details-by-country-offline${
    query ? `?${query}` : ""
  }`;
  const data = await httpService.get(url);
  return data;
};
const getHotelByName = async (cityName, query) => {
  const url = `${apiUrl}/hotel/get-hotel-by-name/${cityName}${
    query ? `?${query}` : ""
  }`;
  const data = await httpService.get(url);
  return data;
};
const updateBooking = async (value) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/hotel/update-hotel-booking-status`,
      value
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};
export {
  getMarkUp,
  addMarkUp,
  getBookingHistory,
  invoiceHandler,
  getBookingDetails,
  offlineTicket,
  getCountry,
  getCityByCountry,
  getHotelByName,
  updateBooking,
};
